import * as types from '../mutation-types'
import store from '~/store'
import axios from 'axios'

// state
export const state = {
  categories: [],
  companies: [],
  printable_types: [],
  projects: [],
  expanded: [],
  my_audits: []
}

// getters
export const getters = {
  categories: state => state.categories,
  companies: state => state.companies,
  printable_types: state => state.printable_types,
  projects: state => state.projects,
  expanded: state => state.expanded,
  my_audits: state => state.my_audits
}

// mutations
export const mutations = {
  [types.SET_SIDEBAR_CATEGORIES] (state, data) {
    state.categories = data;
  },
  [types.SET_SIDEBAR_COMPANIES] (state, data) {
    state.companies = data;
  },
  [types.SET_SIDEBAR_PROJECTS] (state, data) {
    state.projects = data;
  },
  [types.SET_SIDEBAR_PRINTABLETYPES] (state, data) {
    state.printable_types = data;
  },
  [types.SET_SIDEBAR_MY_AUDITS] (state, data) {
    state.my_audits = data;
  },
  [types.SET_SIDEBAR] (state, data) {
    
  },
  [types.CLEAR_SIDEBAR] (state,section) {
    /*
      Temporary commented out to see if glitching UI will be resolved
    */
    //state[section] = [];
  },
  [types.SET_EXPANDED] (state, { data }) {
    if(state.expanded.includes(data.id)){
      state.expanded = state.expanded.filter(e => e !== data.id)
    } else {
      state.expanded.push(data.id)
    }
  }
}

// actions
export const actions = {
  async fetch(url){
    let { data } = await axios.get(url);
    return data;
  },
  async refresh({ commit }, section){
    if(section){
      await actions['fetch' + section]({ commit }, auth.getters.company)
    }
  },
  async fetchCategories({ commit }, company_id){
    const data = await actions.fetch('/api/sidebar/' + company_id + '?section=categories');
    
    commit(types.CLEAR_SIDEBAR,'categories');
    setTimeout(() => {
      commit(types.SET_SIDEBAR_CATEGORIES, data)
    }, 1);
  },
  async fetchCompanies({ commit }){
    let data = await actions.fetch('/api/sidebar/0?section=companies');

    commit(types.CLEAR_SIDEBAR,'companies');

    setTimeout(() => {
      commit(types.SET_SIDEBAR_COMPANIES, data)
    }, 1);
  },
  async fetchProjects({ commit }, company_id){
    let data = await actions.fetch('/api/sidebar/' + company_id + '?section=projects');
        
    commit(types.CLEAR_SIDEBAR,'projects');
    setTimeout(() => {
      commit(types.SET_SIDEBAR_PROJECTS, data)
    }, 1);
  },
  async fetchPrintableTypes({ commit }, company_id){
    const data = await actions.fetch('/api/sidebar/' + company_id + '?section=printable_types');
        
    commit(types.CLEAR_SIDEBAR,'printable_types');
    
    setTimeout(() => {
      commit(types.SET_SIDEBAR_PRINTABLETYPES, data)
    }, 1);
  },
  async fetchMyAudits({ commit }, company_id){
    const data = await actions.fetch('/api/sidebar/' + company_id + '?section=my_audits');
        
    commit(types.CLEAR_SIDEBAR,'my_audits');
    
    setTimeout(() => {
      commit(types.SET_SIDEBAR_MY_AUDITS, data)
    }, 1);
  },
  fetchSidebar ({ commit }, company_id) {
      actions.fetchCategories({ commit }, company_id);
      actions.fetchProjects({ commit }, company_id);
      actions.fetchPrintableTypes({ commit }, company_id);
      actions.fetchMyAudits({ commit }, company_id);

      /* Refresh sidebar every minute */
      /*setTimeout(function(){
        let company = store.getters['auth/company'];
        actions.fetchSidebar({ commit }, company.id);
      },60000);*/
  },
  setExpanded({ commit },data){
    commit(types.SET_EXPANDED, { data })
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/sidebar.js